import { ChakraStylesConfig, GroupBase } from 'chakra-react-select';

/* Until the Select round owns these pickers they wear the ComplyKit entry frame
 * from the tokens, the way the markdown editor does, so a form reads as one. */
export const entryFrameStyles = {
  fontSize: '0.875rem',
  lineHeight: '1.25rem',
  borderColor: 'var(--ck-border-default)',
  borderRadius: 'var(--ck-radius-3)',
  transitionProperty: 'color, background-color, border-color, box-shadow',
  transitionTimingFunction: 'var(--ck-motion-ease-standard)',
  transitionDuration: 'var(--ck-motion-duration-fast)',
  _dark: { bg: 'var(--ck-neutral-a-2)' },
  _hover: { borderColor: 'var(--ck-border-active)' },
  _focusVisible: {
    borderColor: 'var(--ck-accent-8)',
    boxShadow: '0 0 0 3px var(--ck-focus-halo)',
  },
  _invalid: {
    borderColor: 'var(--ck-error-border)',
    boxShadow: 'none',
    _focusVisible: {
      borderColor: 'var(--ck-error-border)',
      boxShadow: '0 0 0 3px var(--ck-error-halo)',
    },
  },
} as const;

/* The field's md step: 32px tall, the value 12px from the edge (10px plus the
 * library's 2px margin on the value, placeholder and input). A picker with its
 * own size (the compact table filters) keeps it. */
const selectStyles: ChakraStylesConfig = {
  control: (base, state) => ({
    ...base,
    ...entryFrameStyles,
    ...(state.selectProps.size ? {} : { minH: '2rem' }),
  }),
  valueContainer: (base, state) => ({
    ...base,
    ...(state.selectProps.size ? {} : { px: '10px' }),
  }),
  placeholder: (base) => ({
    ...base,
    color: 'var(--ck-text-muted)',
  }),
  option: (base) => ({
    ...base,
    fontSize: '0.875rem',
  }),
  noOptionsMessage: (base) => ({
    ...base,
    fontSize: '0.875rem',
  }),
  loadingMessage: (base) => ({
    ...base,
    fontSize: '0.875rem',
  }),
};

export function getSelectStyles<
  TOption,
  IsMulti extends boolean,
  TGroup extends GroupBase<TOption>,
>() {
  return selectStyles as unknown as ChakraStylesConfig<TOption, IsMulti, TGroup>;
}
